module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_8003.1ca7facc.png";